module.exports = __webpack_public_path__ + "img/people.1423ed5c.png";